import { Box } from 'component/base/Grid';
import { Design } from 'enums/design';
import styled, { css } from 'styled-components';

interface LabelProps {
  $inline?: boolean;
}

export const Action = styled(Box)`
  a {
    border-bottom: none !important;
    font-weight: 600;
  }
`;

Action.defaultProps = {
  ml: 'auto',
};

export const Label = styled.label<LabelProps>`
  width: 100%;
  text-align: left;
  color: ${(props) => props.theme.colors.steel};
  ${({ $inline }) => {
    if ($inline) {
      return css`
        align-items: baseline;
        display: flex;

        & > :nth-child(2) {
          flex: 1;
          margin-left: 8px;
        }
      `;
    }
    return '';
  }};
`;

export const LabelText = styled.span`
  color: ${(props) => props.theme.colors.darkBlue};
  font-weight: 500;
  margin-top: 8px;
  margin-bottom: 0.5em;
`;

export const OptionalText = styled.span`
  color: ${(props) => props.theme.colors.steel};
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  margin-top: 8px;
  margin-bottom: 0.5em;
  margin-left: 5px;
`;

export const FieldContainer = styled(Box)`
  position: relative;
`;

export const ErrorMessage = styled.p`
  margin-top: 8px;
  ${(props) => props.theme.text.BodySmall};
  color: ${(props) => props.theme.colors.deepRose};
`;

export const SectionHeading = styled(Box)`
  color: ${(props) => props.theme.colors.darkBlue};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
`;

SectionHeading.defaultProps = {
  mb: 16,
};

interface IconContainerProps {
  design?: Design;
}

export const IconContainer = styled.div<IconContainerProps>`
  position: absolute;
  right: 11px;
  top: 11px;
  opacity: 0.5;

  ${(props) =>
    props.design === Design.LARGE &&
    css`
      top: 15px;
    `}
`;
